import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, switchMap, throwError } from 'rxjs';

import { decryptData, encryptData } from '@helpers';
import { EncryptionBase } from '@models/encryption-base.model';
import { ResponseBase } from '@models/response-base.model';
import { PassphraseService } from '@services/passphrase.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {
  constructor(private passphraseService: PassphraseService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('passphrase') || !request.url.startsWith(environment.apiUrl)) {
      return next.handle(request);
    }

    const notEncrypt = request.params.get('notEncrypt') ?? false;
    const loading = request.params.get('loader') === 'false' ? false : true;

    return this.passphraseService.post(loading).pipe(
      map(data => {
        const requestPassphrase = data.find(x => x.type === 'request');
        const responsePassphrase = data.find(x => x.type === 'response');
        if (requestPassphrase && responsePassphrase) {

          let requestPayload = null;
          if (notEncrypt) {
            requestPayload = request.body;
          } else {
            requestPayload = encryptData(request.body, requestPassphrase.passphrase);
          }

          return {
            requestPayload: requestPayload,
            responsePassphrase: responsePassphrase.passphrase,
            reqUUID: requestPassphrase.uuid,
            resUUID: responsePassphrase.uuid
          };
        }

        throw new Error();
      }),
      switchMap(encryption => {
        if (encryption.requestPayload) {
          let body: EncryptionBase | object = { payload: encryption.requestPayload };
          if (notEncrypt) {
            body = encryption.requestPayload;
          }
          request = request.clone<EncryptionBase | object>({ body });
        }

        let modifiedParams = request.params;
        if (notEncrypt) {
          modifiedParams = modifiedParams.delete('notEncrypt');
        }

        request = request.clone({
          setHeaders: {
            'Req-UUID': encryption.reqUUID,
            'Res-UUID': encryption.resUUID
          },
          params: modifiedParams
        });
        return next.handle(request).pipe(
          map(event => {
            if (event instanceof HttpResponse && event.body) {
              return event.clone<ResponseBase<unknown>>({
                body: decryptData(event.body.payload, encryption.responsePassphrase)
              });
            }

            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            if (error.error.payload) {
              return throwError(() => ({
                ...error,
                error: decryptData(error.error.payload, encryption.responsePassphrase)
              }));
            }

            return throwError(() => error);
          })
        );
      })
    );
  }
}
